import {Component} from '@angular/core';
import {ButtonComponent, HeadingComponent} from '@icz/angular-essentials';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {AbstractBackendStatusComponent} from '../abstract-backend-status.component';

@Component({
  selector: 'icz-network-unavailable-page',
  templateUrl: './network-unavailable-page.component.html',
  styleUrls: ['./network-unavailable-page.component.scss'],
  imports: [HeadingComponent, ButtonComponent, RouterLink, TranslatePipe]
})
export class NetworkUnavailablePageComponent extends AbstractBackendStatusComponent {
}
